import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { QualificationGroupType } from '../types';
import {QualificationSubGroup} from '../QualificationSubGroup';
import QualificationItemComponent from '../QualificationItemComponent';
// import { StatusIcon } from '../StatusIcon';
import {GroupIcon} from '../GroupIcon';


const QualificationGroup: React.FC<{ group: QualificationGroupType }> = ({ group }) => (
  <Accordion
    disableGutters
    square
    sx={{
      boxShadow: 'none',
      mb: '1px',
      '&:before': { display: 'none' },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ fontSize: '1rem', color: '#1976d2' }} />}
      sx={{
        minHeight: '36px',
        px: 0,
        py: 0,
        '& .MuiAccordionSummary-content': { margin: 0 },
        borderBottom: '1px solid #eee',
      }}
    >
  <Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  width="100%"
  sx={{
    backgroundColor: '#f0f4ff',
    px: 1,
    py: 0.5,
    gap: 1,
  }}
>
  <Typography
    sx={{
      flex: 1,
      minWidth: 0,
      fontWeight: 'bold',
      fontSize: '1rem',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    }}
  >
    {group.group.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase())}
  </Typography>

  <Box
    display="flex"
    alignItems="center"
    sx={{ flexShrink: 0 }}
  >
    <GroupIcon status={group.status} />
    <Typography
      fontSize="0.875rem"
      sx={{ whiteSpace: 'nowrap' }}
    >
      {group.statusMessage}
    </Typography>
  </Box>
</Box>
    </AccordionSummary>

    <AccordionDetails sx={{ px: 0, py: 0 }}>
      {group.subGroups?.map((sub, i) => (
        <QualificationSubGroup key={i} subGroup={sub} />
      ))}
      {group.items?.map((item, i) => (
        <QualificationItemComponent key={i} item={item} />
      ))}
    </AccordionDetails>
  </Accordion>
);

export default QualificationGroup;
